export default __webpack_public_path__ + "static/media/Formular-Bold.149fa2d8.woff";